import React from "react";
import { mapNotifyConfigToDataTable as mapData } from "./Helper";
import ReusableDataTable from "src/components/table/ReusableDataTable";
import GetNotifyConfigColumns from "./ColumnDefinition/NotifyConfigColumn/GetNotifyConfigColumns";

const NotifyConfigTable = ({
  data,
  handleOpenPopup,
  handleDelete,
  onDragEnd,
  status,
}) => {
  const columns = GetNotifyConfigColumns({
    handleOpenPopup,
    handleDelete,
    status,
  });

  return (
    <ReusableDataTable
      columns={columns}
      data={mapData(data)}
      maxHeight={500}
      onDragEnd={onDragEnd}
    />
  );
};

export default NotifyConfigTable;
